var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('animation',{attrs:{"width":_vm.width,"height":_vm.height,"margin":_vm.margin,"autoplay":true,"loop":true,"src":_vm.src,"speed":3}})}
var staticRenderFns = []

export { render, staticRenderFns }